import { render, staticRenderFns } from "./BonusPoints.vue?vue&type=template&id=3143e74a&"
import script from "./BonusPoints.vue?vue&type=script&lang=js&"
export * from "./BonusPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thayamohanmohanathas/Documents/GitHub/Phywe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3143e74a')) {
      api.createRecord('3143e74a', component.options)
    } else {
      api.reload('3143e74a', component.options)
    }
    module.hot.accept("./BonusPoints.vue?vue&type=template&id=3143e74a&", function () {
      api.rerender('3143e74a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/phywe/BonusPoints.vue"
export default component.exports